import React from 'react'
import { circles } from '../../content/csp'

const CirclesTeaser = () => {
  return (
    <section className="csp-section csp-section--tint">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">{circles.kicker}</span>
            <h2 className="csp-title">{circles.title}</h2>
            <p className="csp-lead">{circles.lead}</p>
          </div>
        </div>
        <div className="csp-levels">
          {circles.levels.map((level) => (
            <article className="csp-level" key={level.title}>
              <span className="csp-level-label">Circle</span>
              <h3>{level.title}</h3>
              <p>{level.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CirclesTeaser
